import NotFound from 'components/NotFound';
import BeyondBilling from 'components/practice/BeyondBilling';
import CMS1500 from 'components/practice/BeyondBilling/Claims/CMS1500/CMS1500';
import Eob from 'components/practice/BeyondBilling/Claims/ERA&EOB/EOB/Eob';
import Era from 'components/practice/BeyondBilling/Claims/ERA&EOB/ERA/Era';
import ViewEra from 'components/practice/BeyondBilling/Claims/ERA&EOB/ERA/components/ViewEra/ViewEra';
import NewClaims from 'components/practice/BeyondBilling/Claims/NewClaims';
import DynamicAR from 'components/practice/BeyondBilling/DynamicAR/DynamicAR';
import ElectronicInvoicing from 'components/practice/BeyondBilling/ElectronicInvoicing/ElectronicInvoicing';
import ExternalInvoices from 'components/practice/BeyondBilling/ElectronicInvoicing/ExternalInvoices';
import InternalInvoices from 'components/practice/BeyondBilling/ElectronicInvoicing/InternalInvoices';
import ViewInternalInvoice from 'components/practice/BeyondBilling/ElectronicInvoicing/components/ViewInternalInvoice';
import IncomeIQueue from 'components/practice/BeyondBilling/IncomeIQueue/IncomeIQueue';
import BeyondBillingOverview from 'components/practice/BeyondBilling/Overview/Overview';
import PatientLedger from 'components/practice/BeyondBilling/PatientLedger/PatientLedger';
import Payments from 'components/practice/BeyondBilling/Payments/Payments';
import BeyondBillingReports from 'components/practice/BeyondBilling/Reports/BeyondBillingReports';
import ReportView from 'components/practice/BeyondBilling/Reports/components/ReportView/ReportView';
import CustomReports from 'components/practice/BeyondBilling/Reports/pages/CustomReports/CustomReports';
import FavoriteReports from 'components/practice/BeyondBilling/Reports/pages/FavoriteReports/FavoriteReports';
import StandardReports from 'components/practice/BeyondBilling/Reports/pages/StandardReports/StandardReports';
import Superbills from 'components/practice/BeyondBilling/Superbill/Superbills';

const PRACTICE_BEYOND_BILLING = [
  {
    path: 'beyond-billing',
    element: <BeyondBilling />,
    children: [
      {
        path: 'overview',
        element: <BeyondBillingOverview />
      },
      {
        path: 'income-i-queue',
        element: <IncomeIQueue />
      },
      {
        path: 'payments',
        element: <Payments />,
        children: [
          {
            path: 'era/:id',
            element: <ViewEra />
          }
        ]
      },
      {
        path: 'patient-ledger',
        element: <PatientLedger name="patient_ledger" />
      },
      {
        path: 'dynamic-ar',
        element: <DynamicAR />,
        children: [
          {
            path: ':type',
            element: <DynamicAR />
          }
        ]
      },
      {
        path: 'era-eob',
        children: [
          {
            path: 'era',
            element: <Era />,
            children: [
              {
                path: ':id',
                element: <ViewEra />
              }
            ]
          },
          {
            path: 'eob',
            element: <Eob />,
            children: [
              {
                path: ':id',
                element: <ViewEra />
              }
            ]
          }
        ]
      },
      {
        path: 'claims',
        element: <NewClaims />,
        children: [
          {
            path: ':id',
            element: <CMS1500 />
          },
          {
            path: '*',
            element: <NotFound />
          }
        ]
      },
      {
        path: 'superbills',
        element: <Superbills />,
        children: [
          {
            path: 'claim/:claimId',
            element: <CMS1500 />
          },
          {
            path: '*',
            element: <NotFound />
          }
        ]
      },
      {
        path: 'electronic-invoicing',
        element: <ElectronicInvoicing />,
        children: [
          {
            path: '',
            element: <InternalInvoices />,
            children: [
              {
                path: ':invoiceId',
                element: <ViewInternalInvoice />
              }
            ]
          },
          {
            path: 'external',
            element: <ExternalInvoices />
          },
          {
            path: '*',
            element: <NotFound />
          }
        ]
      },
      {
        path: 'reports',
        element: <BeyondBillingReports />,
        children: [
          // {
          //   path: 'r-overview',
          //   element: <OverviewReports />
          // },
          {
            path: 'standard',
            element: <StandardReports />
          },
          {
            path: 'favorite',
            element: <FavoriteReports />
          },
          {
            path: 'custom',
            element: <CustomReports />
          },
          {
            path: ':id',
            element: <ReportView />
          }
        ]
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  }
];
export default PRACTICE_BEYOND_BILLING;
